// extracted by mini-css-extract-plugin
module.exports = {"rootLink":"usp_rootLink__thi76"};